// src/components/BackupData.jsx
import { useState } from 'react';
import { api } from '../services/api';

export default function BackupData({ onBack }) {
  const [loading, setLoading] = useState(false);
  const [hasil, setHasil] = useState(null);
  const [error, setError] = useState('');

  async function handleBackup() {
    setLoading(true);
    setError('');
    setHasil(null);
    try {
      const res = await api.backupSekarang();
      setHasil(res);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex flex-wrap items-center justify-between gap-3">
          <div className="border-l-4 border-blue-600 pl-3">
            <h1 className="text-xl sm:text-2xl font-bold text-slate-800">Backup Data</h1>
            <p className="text-xs sm:text-sm text-slate-500 mt-0.5">Cadangan seluruh data ke file Excel di Google Drive</p>
          </div>
          <button onClick={onBack} className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-medium px-4 py-2 rounded-lg transition">
            &larr; Kembali ke Dashboard
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-6 space-y-5">
        {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl px-4 py-3">{error}</div>}

        <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="bg-blue-600 px-5 sm:px-6 py-3.5">
            <h2 className="text-sm font-semibold text-white flex items-center gap-2">
              <span aria-hidden="true">&#128190;</span> Backup Manual
            </h2>
          </div>
          <div className="p-5 sm:p-6">
            <p className="text-sm text-slate-600 mb-4">
              Klik tombol ini kapan saja untuk membuat salinan Excel (.xlsx) dari <strong>seluruh sheet</strong>
              (Siswa, Users, Kehadiran, JurnalMengajar, dll) ke folder Google Drive bernama{' '}
              <strong>"Backup Absen Digital"</strong>.
            </p>
            <button
              onClick={handleBackup}
              disabled={loading}
              className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-medium text-sm px-6 py-2.5 rounded-lg transition"
            >
              {loading ? 'Membuat backup...' : 'Backup Sekarang'}
            </button>

            {hasil && (
              <div className="mt-4 bg-green-50 border border-green-200 rounded-xl px-4 py-3">
                <p className="text-sm text-green-800 font-medium">Backup berhasil dibuat ✓</p>
                <p className="text-xs text-green-700 mt-1">Nama file: {hasil.fileName}</p>
                <a
                  href={hasil.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-600 underline mt-1 inline-block"
                >
                  Buka file di Google Drive
                </a>
              </div>
            )}
          </div>
        </section>

        <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="bg-indigo-600 px-5 sm:px-6 py-3.5">
            <h2 className="text-sm font-semibold text-white flex items-center gap-2">
              <span aria-hidden="true">&#9200;</span> Backup Otomatis Harian
            </h2>
          </div>
          <div className="p-5 sm:p-6 space-y-3 text-sm text-slate-600">
            <p>
              Sistem bisa backup sendiri <strong>setiap hari jam 22:00</strong> tanpa perlu diklik manual — tapi ini
              perlu dipasang <strong>sekali saja</strong> langsung dari editor Apps Script (bukan dari halaman ini),
              karena butuh izin akses Google Drive yang hanya bisa diberikan lewat editor tersebut.
            </p>
            <ol className="list-decimal list-inside space-y-1.5 text-slate-500">
              <li>Buka Google Sheet Anda → Extensions → Apps Script</li>
              <li>Di dropdown pilihan function (atas), pilih <code className="bg-slate-100 px-1.5 py-0.5 rounded">setupBackupTrigger</code></li>
              <li>Klik tombol Run (▷), lalu Izinkan/Allow akses Drive kalau diminta</li>
              <li>Selesai — tidak perlu diulang lagi setelah ini</li>
            </ol>
            <p className="text-xs text-slate-400">
              Backup lama otomatis dibersihkan — sistem hanya menyimpan 14 backup terakhir supaya Google Drive
              tidak penuh.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
